import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpService} from "../http/http.service";


@Injectable()
export class NotificationService {
  private url = '/api/notifications';

  constructor(private httpService: HttpService) {
  }

  regist(token: string): Observable<any> {
    return this.httpService.post(`${this.url}?token=${token}`, null);
  }

  unregist(token: string): Observable<any> {
    return this.httpService.delete(`${this.url}?token=${token}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/notification/notification.service.ts